import Form from "../Form/Form";
import css from "./AddEquipment.module.css";
import SalesEquipmentOptions from "./SalesEquipmentOptions";
import Url from "../../Services/Url";
import { Get } from "../../Services/Server";
import { useState } from "react";
const AddSalesEquipment = ({ onSubmit }) => {
	const [options, setOptions] = useState(SalesEquipmentOptions);
	const init = () => {
		const op = { ...options };
		op.Fields[0].value = "";
		op.Fields[1].value = "";
		setOptions(op);
	};
	const handleSubmit = () => {
		onSubmit && onSubmit(options);
		init();
	};
	return (
		<div className={css.AddEquipment}>
			{" "}
			{options && <Form onSubmit={handleSubmit}>{options}</Form>}{" "}
		</div>
	);
};
export default AddSalesEquipment;
